<div *ngIf='(vm$ | async) as vm'>
    <app-page-header [vm]="vm" title='Tour Management' [canGoBack]="true" [canRefresh]="true" [canAddNew]="true"
        (refreshClick)="refreshPage()" (addNewClick)="addNewTour()" [notify]="notifyObj"></app-page-header>

    <mdb-card cascade="true" narrower="true" class="my-3">
        <mdb-card-body>
            <div class="row mt-n4 mb-n4">
                <!--<div class="col-md-1">
                    <div class="md-form form-group">
                        <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect (click)="addNewTour()"
                            mdbTooltip="Add New Tour">
                            <mdb-icon fas icon="plus"></mdb-icon>
                        </a>
                    </div>
                </div>-->
                <div class="col-md-2">
                    <div class="mx-2">
                        <div class="md-form form-group">
                            <mdb-date-picker name="startDate" [inline]="true" [options]="tmDatePickerOptions"
                                [placeholder]="'Selected start date'" [(ngModel)]="startDate"></mdb-date-picker>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="mx-2">
                        <div class="md-form form-group">
                            <mdb-date-picker name="endDate" [inline]="true" [options]="tmDatePickerOptions"
                                [placeholder]="'Selected end date'" [(ngModel)]="endDate"></mdb-date-picker>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="mx-2">
                        <div class="md-form form-group form-sm">
                            <mdb-icon fas icon="user-alt" class="prefix"></mdb-icon>
                            <input mdbInput type="text" id="bookingAgentCode" class="form-control"
                                [(ngModel)]="bookingAgentCode">
                            <label for="bookingAgentCode">Booking Agent Code</label>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="mx-2">
                        <div class="md-form form-group form-sm">
                            <mdb-icon fas icon="user-alt" class="prefix"></mdb-icon>
                            <input mdbInput type="text" id="customerCode" class="form-control"
                                [(ngModel)]="customerCode">
                            <label for="customerCode">Customer Code</label>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="mx-2">
                        <div class="md-form form-group form-sm">
                            <mdb-icon fas icon="user-alt" class="prefix"></mdb-icon>
                            <input mdbInput type="text" id="passengerCode" class="form-control"
                                [(ngModel)]="passengerCode">
                            <label for="passengerCode">Passenger Code</label>
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="mx-2">
                        <div class="md-form form-group form-sm">
                            <mdb-icon fas icon="users" class="prefix"></mdb-icon>
                            <input mdbInput type="text" id="eventCode" class="form-control"
                                [(ngModel)]="eventCode">
                            <label for="eventCode">Event Code</label>
                        </div>
                    </div>
                </div>
            </div>
        </mdb-card-body>
    </mdb-card>

    <div class="row pt-3" *ngFor="let g of vm.tourGroupDetailsFiltered">
        <!--<div class="container-fluid">
            <div class="card card-cascade narrower">
                <mdb-card>
                    <mdb-body>
                        <div class="row">
                            <div class="col-xl-3 col-md-12 col-lg-12 mr-0">
                                <div class="view view-cascade gradient-card-header blue-gradient py-2">
                                    <h2 class="h3-responsive card-title font-weight-bold mb-0">{{g.groupName}}</h2>
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12 col-lg-12 mr-0">
                                <div class="card-body card-body-cascade">
                                    <div class="col-md-12">
                                        <div class="d-flex flex-wrap">
                                            <div class="m-2" *ngFor="let d of g.details">
                                                <div (click)="click(d)" style="cursor: pointer;">
                                                    <mdb-card [ngClass]="!vm.selectionDisallowed ? 'div_hover' : ''">
                                                        <mdb-card-body>
                                                            <mdb-card-title>
                                                                <span class="h5-responsive">{{d.title}}</span>
                                                            </mdb-card-title>
                                                            <mdb-card-text>
                                                                <span>{{d.startDate | date: 'dd/MM/yyyy'}} - {{d.endDate | date:
                                                                    'dd/MM/yyyy'}}</span>
                                                            </mdb-card-text>
                                                        </mdb-card-body>
                                                    </mdb-card>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mdb-body>
                </mdb-card>
            </div>
        </div>-->
        <div class="col-md-12">
            <div>
                <span class="h1-responsive">{{g.groupName}}</span>
                <hr class="solid my-0">
            </div>
        </div>
        <div class="col-md-12">
            <div class="d-flex flex-wrap">
                <div class="m-2" *ngFor="let d of g.details">
                    <div (click)="click(d)" style="cursor: pointer;">
                        <mdb-card [ngClass]="!vm.selectionDisallowed ? 'div_hover' : ''">
                            <mdb-card-body>
                                <mdb-card-title>
                                    <span class="h5-responsive">{{d.title}}</span>
                                </mdb-card-title>
                                <mdb-card-text>
                                    <span>{{d.startDate | date: 'dd/MM/yyyy'}} - {{d.endDate | date:
                                        'dd/MM/yyyy'}}</span>
                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>